import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { RequiredLegend } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './radio-element.style.js';
import { isChecked, handleMultipleChoiceInput } from '../multiple-choice-input';

export class RadioElement extends Component {
  handleInput(value, checked) {
    const { response, defaultValue, onChange } = this.props;
    var modifiedValue = handleMultipleChoiceInput(response, defaultValue, value, checked, true);
    onChange(modifiedValue);
  }

  hasValue() {
    const { response, defaultValue } = this.props;
    return response ? response.size > 0 : defaultValue ? defaultValue.size > 0 : false;
  }

  render() {
    const { response, defaultValue, isRequired, hidden, label, tooltip, options, id, disabled, readOnly, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');

    if(hidden) return null;

    return (
      <fieldset
        id={id}
        role="radiogroup"
        className={css.fieldset}
        aria-required={isRequired}
        aria-invalid={hasErrors && showErrors}
        aria-describedby={errorIds}>
        <RequiredLegend
          hasErrors={hasErrors && showErrors}
          content={label}
          tooltip={tooltip}
          isRequired={isRequired}
          css={{
            requiredLegend: css.label,
            requiredIndicator: css.requiredIndicator}}/>
        <div className={this.hasValue() ? css.buttons : css.buttonsEmpty}>
          {options.map(option => (
            <div key={`${id}-${option.value}`} className={css.buttonWrapper}>
              <label className={css.buttonLabel} htmlFor={option.id}>
                <input
                  name={'group' + id}
                  id={option.id}
                  className={readOnly ? css.readOnly : css.radioButton}
                  value={option.value}
                  type="radio"
                  disabled={disabled}
                  onChange={e => {
                    if(readOnly)
                      return false;
                  return this.handleInput(e.target.value, !isChecked(response, defaultValue, option.value));
                  }}
                checked={isChecked(response, defaultValue, option.value)} />
                <span>
                {option.label}
                </span>
              </label>
              <div className={css.buttonDetail}>{option.detail}</div>
              <br/>
            </div>
          ))}
        </div>
      </fieldset>
    );
  }
}

RadioElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  options: PropTypes.array.isRequired,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.any,
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  errors: PropTypes.object,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (RadioElement);
